{
  "list": {
    "title": "Inbox",
    "loadFailed": "Unable to load conversations",
    "searchPlaceholder": "Search…",
    "needsAttention": "Needs a human",
    "clearFilters": "Clear filters",
    "tabAll": "All",
    "tabUnread": "Unread",
    "emptyNoConversations": "No conversations",
    "emptyNoUnread": "No new messages",
    "emptyNoMatches": "No conversations match these filters",
    "reauthRequired": "⚠ Reconnection needed · ",
    "customerInfoAria": "Customer details",
    "linkUnavailable": "This conversation isn't available. It may have been deleted or belong to another shop.",
    "viaChannel": "via {{channel}}"
  },
  "welcome": {
    "title": "Welcome to your inbox",
    "body": "Pick a customer from the list on the left to open the conversation and start chatting",
    "queueTitle": "Waiting for a person",
    "queueBody": "The AI passed these chats to your team. Pick one to reply, or choose any chat from the list."
  },
  "thread": {
    "backAria": "Back",
    "customerInfoAria": "View customer details",
    "messagesAria": "Messages",
    "loadingMessages": "Loading messages…",
    "loadingOlder": "Loading older messages…",
    "loadOlderFailed": "Couldn't load older messages",
    "retryLoadOlder": "Try again",
    "empty": "No messages yet",
    "botTag": "AI",
    "sendFailed": "Not sent",
    "sendMessageFailed": "Unable to send the message. Try again.",
    "composerPlaceholder": "Type a message…",
    "sendAria": "Send message",
    "imageAlt": "Image",
    "stickerAlt": "Sticker",
    "imageUnavailable": "Image unavailable",
    "stickerUnavailable": "Sticker unavailable",
    "retryMedia": "Try again",
    "mediaLoading": "Loading image",
    "fileFallback": "Attachment",
    "channelDisabledTitle": "This channel is disabled",
    "channelDisabledBody": "Enable {{channel}} in channel settings to reply to customers",
    "channelReauthTitle": "This channel has lost its connection",
    "channelReauthBody": "Reconnect {{channel}} to reply to customers",
    "goToSettings": "Go to settings"
  },
  "window": {
    "minutes_one": "{{count}} minute",
    "minutes_other": "{{count}} minutes",
    "hoursMinutes": "{{hours}}h {{minutes}}m",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "daysHours": "{{days}}d {{hours}}h",
    "humanAgentWindow": "Manual reply · {{remaining}} left",
    "humanAgentHint": "Past {{platform}}'s 24-hour window. You can still reply yourself for 7 days, but the bot can't.",
    "metaWindowReason": "{{platform}} doesn't allow replies more than 7 days after the customer's last message",
    "metaWindowReasonStandard": "{{platform}} doesn't allow replies more than 24 hours after the customer's last message",
    "freeReply": "✓ Free reply for {{remaining}}",
    "unlimited": "Unlimited messages",
    "remainingThisMonth_one": "{{count}} message left this month",
    "remainingThisMonth_other": "{{count}} messages left this month",
    "usageThisMonth": "{{used}} / {{cap}} messages this month",
    "replyWithin": "{{remaining}} left to reply",
    "lineQuotaReason": "You've used this month's LINE quota. Upgrade your LINE plan to send more.",
    "lineQuotaPlaceholder": "Can't send — quota used up",
    "metaWindowPlaceholder": "Reply window closed"
  },
  "bot": {
    "label": "Auto-reply bot",
    "toggleFailed": "Couldn't change the bot's status",
    "enabled": "Bot enabled",
    "disabled": "Bot paused",
    "tooltipActive": "The bot is replying automatically",
    "tooltipPaused": "Bot paused — click to enable",
    "unavailable": "Off for {{platform}}",
    "unavailableLink": "Turn on",
    "unavailableTooltip": "The shop's AI assistant doesn't reply on {{platform}}. Turn {{platform}} on in AI assistant settings.",
    "pendingAria": "Order awaiting bot approval",
    "pendingTitle": "Awaiting your approval",
    "suggested": "Bot suggested",
    "total": "Total",
    "recipient": "Recipient",
    "confirm": "Approve",
    "reject": "Reject",
    "loadActionsFailed": "Unable to load pending approvals",
    "approveSuccess": "Order approved",
    "rejectSuccess": "Order rejected"
  },
  "customer": {
    "linkTitle": "Link to a customer",
    "linkSuccess": "Customer linked",
    "linkFailed": "Couldn't link that customer",
    "unlinkSuccess": "Customer unlinked",
    "unlinkFailed": "Couldn't unlink that customer",
    "searchPlaceholder": "Name • Phone • #tag",
    "searching": "Searching...",
    "notFound": "No customers found",
    "cancel": "Cancel",
    "statOrders": "Orders",
    "statTotal": "Lifetime value",
    "linkBeforeOrder": "Link a customer before creating an order",
    "createOrder": "Create order",
    "tabProfile": "Profile",
    "tabOrders": "Orders ({{count}})",
    "tabNotes": "Notes",
    "rowEmail": "Email",
    "rowPhone": "Phone",
    "linkToSeeOrders": "Link a customer to see their orders",
    "noOrders": "No orders yet",
    "refresh": "Refresh",
    "linkToWriteNotes": "Link a customer to write notes",
    "notesPlaceholder": "Notes about this customer — VIP, preferences, allergies, and so on",
    "notesSaved": "Note saved",
    "notesFailed": "Couldn't save that note",
    "save": "Save",
    "loadOrdersFailed": "Unable to load this customer's orders"
  },
  "order": {
    "title": "Order #{{label}}",
    "summary": "{{count}} items · {{total}} total",
    "itemsCount_one": "{{count}} item",
    "itemsCount_other": "{{count}} items",
    "view": "View order",
    "resend": "Send to customer again",
    "resendSuccess": "Sent to the customer again",
    "resendNoChat": "This customer has no chat to send the card to",
    "resendFailed": "Couldn't resend",
    "moreLines_one": "and {{count}} more item",
    "moreLines_other": "and {{count}} more items"
  },
  "referral": {
    "ad": "via Facebook ad",
    "link": "via link {{ref}}",
    "source": "via {{source}}",
    "detailSource": "Source: {{value}}",
    "detailType": "Type: {{value}}",
    "detailRef": "Reference: {{value}}",
    "detailAdId": "Ad ID: {{value}}"
  }
}
